import React from 'react';

const ActivitiesFilter = ({ activityType, onTypeChange }) => {
  // Activity types
  const types = [
    { value: 'all', label: 'All Activities' },
    { value: '0', label: 'Investments' },
    { value: '1', label: 'Referral Rewards' },
    { value: '2', label: 'Royalty Distributions' }
  ];

  // Handle filter change
  const handleTypeChange = (e) => {
    onTypeChange(e.target.value);
  };

  return (
    <div className="activities-filter">
      <div className="filter-group">
        <label htmlFor="activityType">Filter by Type:</label>
        <select 
          id="activityType"
          value={activityType}
          onChange={handleTypeChange}
        >
          {types.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ActivitiesFilter;
